import React, { useEffect, useState } from "react";
import Loading from "../../../Components/Loading";
import Handler from "../../../Helpers/Handler";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../Contexts/AuthenticateProvider";
import BackButton from "../../../Components/BackButton";
import { FiEdit } from "react-icons/fi";
import { GiCarSeat, GiCheckMark, GiGearStick, GiSteeringWheel, GiTyre } from "react-icons/gi";
import { BsDistributeHorizontal, BsEarbuds, BsFillFuelPumpFill, BsFillLuggageFill, BsFillPatchCheckFill, BsFillPatchExclamationFill, BsPersonVideo3, BsTools } from "react-icons/bs";
import { Badge, DetailCard, KycCard, Stat } from "../../../Components/Needed";
import { FaBluetooth, FaBook, FaBookOpen, FaCalendar, FaCar, FaCaretLeft, FaCaretRight, FaCarSide, FaCloudUploadAlt, FaExclamation, FaImage, FaSprayCan } from "react-icons/fa";
import { FaCircleCheck, FaIndianRupeeSign, FaShield } from "react-icons/fa6";
import { MdAirlineSeatReclineNormal, MdCancel, MdFlipCameraIos, MdGpsFixed, MdOutlineCurrencyRupee } from "react-icons/md";
import Timeline from "../../../Components/Timeline";
import { IoIosColorPalette } from "react-icons/io";
import { PiCertificateFill } from "react-icons/pi";
import { toast } from "react-toastify";
import { RiBattery2ChargeFill, RiImageEditFill, RiUserVoiceFill } from "react-icons/ri";
import { BiBroadcast } from "react-icons/bi";
import { TbAirConditioning } from "react-icons/tb";
import { SiAdguard, SiApplemusic } from "react-icons/si";
import CarImages from './CarImages'
import DeviceRegister from './DeviceRegister'
import CarVerification from "./CarVerify";
import Slider from "react-slick";
import moment from "moment";
import DatePicker from "react-multi-date-picker";
import BookingDetails from "./BookingDetails";
import Service from './Service'
import { IoCloudUploadOutline, IoDocumentTextSharp, IoShieldCheckmark } from "react-icons/io5";
import { reloadWindow, showFullDate, showZoneDate, showZoneTime } from "../../../Helpers/Utils";
import { CiCreditCard2 } from "react-icons/ci";

const View = () => {
    const { hasPermission } = useAuth();
    // Controls are hidden when the role lacks the capability. The router
    // enforces the same keys - this just keeps dead buttons off the page.
    const canUpdate = hasPermission("vehicle.car.update");
    const canStatus = hasPermission("vehicle.car.status");
    const canDocuments = hasPermission("vehicle.car.documents");
    const canTracking = hasPermission("vehicle.car.tracking");
    // The verification chain advances through three different capabilities, so the
    // single Verify button is only offered when the CURRENT step is permitted.
    const canImages = hasPermission("vehicle.car.images");
    const canDevice = hasPermission("vehicle.car.device");
    const canVerify = hasPermission("vehicle.car.verify");
    const canTimeline = hasPermission("vehicle.car.timeline");
    const canPrice = hasPermission("vehicle.car.price");
    const canService = hasPermission("service.view");
    // The device step LEAVES this page for /car/device/:id, which also loads the
    // hub list and the model's service schedule. Offering the button without
    // those would send someone to a form they can never submit, so the button
    // requires the same set the route does.
    const canHubView = hasPermission("hub.view");
    const canModelView = hasPermission("vehicle.model.view");
    const canDeviceStep = canDevice && canHubView && canModelView;
    const canBookings = hasPermission("booking.view");
    const { id } = useParams()
    const [loading, setLoading] = useState(true);
    const [priceUpdate, setpriceUpdate] = useState(false)
    const [price, setPrice] = useState({ perHourKm: 0, perHourPrice: 0, package: 0 })
    const [carDetails, setCarDetails] = useState([])
    const verificationStage = carDetails?.verificationStage || 0;
    // Which capability the Verify button needs depends on where the car is:
    // 20 -> upload images, 50 -> register device, 70 -> price and approve.
    const canAdvanceStage = verificationStage === 20 ? canImages : verificationStage === 50 ? canDeviceStep : verificationStage === 70 ? canVerify : false;
    const [userLog, setUserLog] = useState([]);
    const [status, setStatus] = useState(false)
    const navigate = useNavigate()
    const [currentImg, setCurrentImg] = useState(0);
    const [stage, setStage] = useState(false)
    const [imageModal, setImageModal] = useState(false)
    const [updateImage, setUpdateImage] = useState()
    const [document, setDocument] = useState({})
    const [documentUpload, setDocumentUpload] = useState(false)
    const [documentUploadDetails, setDocumentUploadDetails] = useState({
        documentName: "",
        documentValidity: new Date(),
        document: null
    })
    const [docEditModal, setDocEditModal] = useState(false)
    const [docDetail, setDocDetail] = useState({ url: "", validity: "" })
    const [rc, setRc] = useState({})
    const settings = {
        dots: false,
        infinite: carDetails?.carImages?.length > 5,
        speed: 500,
        slidesToShow: Math.min(carDetails?.carImages?.length || 1, 4),
        slidesToScroll: 1,
        autoplay: true,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        nextArrow: <FaCaretRight className='slick-arrow' />,
        prevArrow: <FaCaretLeft className='slick-arrow' />,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                }
            }
        ]
    };
    const featureIcons = [
        { icon: <BsFillLuggageFill />, value: "Luggage" },
        { icon: <RiBattery2ChargeFill />, value: "Mobile Charger" },
        { icon: <MdAirlineSeatReclineNormal />, value: "Baby Seat" },
        { icon: <BsTools />, value: "Puncture Kit" },
        { icon: <FaSprayCan />, value: "Air Freshener" },
        { icon: <RiUserVoiceFill />, value: "Voice Control" },
        { icon: <MdFlipCameraIos />, value: "Reverse Camera" },
        { icon: <BiBroadcast />, value: "Reverse Sensor" },
        { icon: <FaBluetooth />, value: "Bluetooth" },
        { icon: <TbAirConditioning />, value: "AC" },
        { icon: <SiApplemusic />, value: "Music System" },
        { icon: <GiSteeringWheel />, value: "Power Steering" },
        { icon: <BsPersonVideo3 />, value: "Power Window" },
        { icon: <GiTyre />, value: "Spare Tyre" },
        { icon: <FaShield />, value: "Air Bag" },
        { icon: <BsEarbuds />, value: "Aux Input" },
        { icon: <BsDistributeHorizontal />, value: "Boot Space" }
    ]
    const fetchCarDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: "get", url: `/staff/car/details/${id}`, });
        if (response?.success) {
            const data = response?.data?.data
            setCarDetails(data);
            setCarDetails(prev => ({ ...prev, warrantyDocuments: data?.documents?.length ? data?.documents?.filter(element => element?.documentName !== "RC" && element?.documentName !== "PUC" && element?.documentName !== "INSURANCE") : [] }))
            setRc(data?.documents?.length ? data?.documents?.find(element => element?.documentName === "RC") : {})
        }
        setLoading(false)
    };
    const updateDocument = async () => {
        if (docDetail?.url) {
            setLoading(true)
            const formData = new FormData()
            formData?.append(docDetail?.documentName?.toLowerCase(), docDetail?.documentName)
            formData?.append(docDetail?.documentName?.toLowerCase(), docDetail?.url)
            docDetail?.validity && formData?.append('validity', new Date(docDetail?.validity))
            const response = await Handler({ method: 'PATCH', url: `/staff/car/${docDetail?.documentName?.toLowerCase()}/${id}`, formdata: true, data: formData })
            if (response.success) {
                toast.success(response?.data?.message)
                setDocEditModal(false)
                fetchCarDetails()
                fetchUserLog()
            } else {
                toast.error(response?.data?.message)
            }
            setLoading(false)
        } else {
            toast.error("Image is required")
        }
    }
    const fetchUserLog = async () => {
        // The log endpoint is gated on vehicle.car.timeline; without it there is
        // nothing to show, so skip the call rather than provoke a 403.
        if (!canTimeline) return;
        setLoading(true)
        const response = await Handler({ method: "get", url: `/staff/car/log/${id}`, });
        if (response?.success) setUserLog(response?.data?.data || []);
        setLoading(false)
    };
    const statusUpdate = async () => {
        if (carDetails.status && !carDetails.reason) {
            toast.error("Reason is required")
            return
        }
        setLoading(true)
        let data = {}
        if (carDetails.status) data['reason'] = carDetails.reason || ""
        const response = await Handler({ method: 'PATCH', url: `/staff/car/status/${id}?status=${!carDetails.status}`, data })
        if (response?.success) {
            toast.success(response?.data?.message)
            fetchCarDetails()
            fetchUserLog()
            setStatus(false)
        } else {
            toast.error(response?.data?.message)
        }
        setLoading(false)
    }
    const imageChange = async (e) => {
        setLoading(true)
        const imgId = updateImage?.src?.split("/")?.pop()?.split(".")[0]
        const formData = new FormData();
        formData.append("car", updateImage?.file)
        const response = await Handler({ method: 'PATCH', url: `/staff/car/single/carImage/${id}?imageId=${imgId}`, data: formData, formdata: true })
        if (response?.success) {
            toast.success(response.data?.message)
            setImageModal(false)
            fetchCarDetails()
            fetchUserLog()
        } else {
            toast.error(response.data?.message)
        }
        setLoading(false)
    }
    const handlePriceUpdate = async () => {
        if (price?.perHourPrice <= 0 || !price?.perHourPrice) {
            toast.error("Invalid price")
        } else {
            setLoading(true);
            const response = await Handler({ method: 'PATCH', url: `/staff/car/price/${id}`, data: { package: price?.package, perHourKm: price?.perHourKm, perHourPrice: price?.perHourPrice } })
            if (response?.success) {
                toast.success(response?.data?.message)
                fetchCarDetails()
                fetchUserLog()
                setpriceUpdate(false)
            } else {
                toast.error(response?.data?.message)
            }
            setLoading(false)
        }
    }
    const uploadDocument = async () => {
        try {
            const { documentName, documentValidity, document } = documentUploadDetails || {};
            if (!documentName?.trim()) return toast.error("Document name is required");
            if (!documentValidity) return toast.error("Document validity is required");
            const validityDate = new Date(documentValidity);
            validityDate.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (validityDate <= today) return toast.error("Document validity must be greater than today");
            if (!document) return toast.error("Please select a document");
            const maxSize = 5 * 1024 * 1024;
            if (document.size > maxSize) return toast.error("File size should not exceed 5 MB");
            const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg", "image/png",];
            if (!allowedTypes.includes(document.type)) return toast.error("Only PDF, JPG, JPEG, and PNG files are allowed");
            setLoading(true);
            const formData = new FormData();
            formData.append("documentName", documentName.trim());
            formData.append("documentValidity", documentValidity);
            formData.append("document", document);
            const response = await Handler({ method: "PATCH", url: `/staff/car/documents/${id}`, data: formData, formdata: true, });
            if (response?.success) {
                toast.success(response?.data?.message);
                reloadWindow()
            } else {
                toast.error(response?.data?.message || "Failed to upload document");
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (documentUpload === false) {
            setDocumentUploadDetails({
                documentName: "",
                documentValidity: new Date(),
                document: null
            })
        }
    }, [documentUpload])
    useEffect(() => {
        fetchCarDetails();
        fetchUserLog();
    }, []);
    if (loading) {
        return <Loading />
    }

    return (
        <React.Fragment>
            <div>
                <div className="row">
                    <div className="col-12 mb-3" > <BackButton name="to List" /> </div>
                    <div className="col-12 mb-4">
                        <div className="card border-0 shadow-sm rounded-4">
                            <div className="p-3" >
                                <div className="d-sm-flex justify-content-between mb-2">
                                    <h5 className="fw-semibold d-flex align-items-center justify-content-sm-strat justify-content-center mb-sm-0 mb-2 gap-2"> <FaCar /> Car Details</h5>
                                    <div className="justify-content-sm-end d-flex align-items-center justify-content-center gap-1">
                                        {canUpdate ? <button className="btn d-flex align-items-center gap-1" onClick={() => { navigate(`/car/update/${id}`) }} ><FiEdit /><span> Edit</span></button> : ""}
                                        {canStatus ? <button disabled={loading} className={`btn btn-sm ${carDetails?.status ? 'btn-danger' : 'btn-success'}`} onClick={() => { setCarDetails(prev => ({ ...prev, reason: "" })); setStatus(true) }} > {carDetails?.status ? 'Deactivate' : 'Activate'}</button> : ""}
                                    </div>
                                </div>
                                <hr className="m-0" />
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 col-xl-7">
                                        <div className="d-flex flex-column flex-md-row gap-4">
                                            <div className="flex-grow-1">
                                                <div className="row g-4">
                                                    <div className="col-lg-6">
                                                        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                                                            <img
                                                                src={
                                                                    carDetails?.carImages?.[0] ||
                                                                    "https://placehold.net/400x400.png"
                                                                }
                                                                alt="Car"
                                                                className="img-fluid"
                                                                style={{
                                                                    height: "280px",
                                                                    objectFit: "cover"
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="w-100 mt-2">
                                                            <div className="bg-light rounded-3 p-3">
                                                                <small className="text-muted d-block">
                                                                    Owned By
                                                                </small>
                                                                <span className="fw-semibold text-capitalize">
                                                                    {carDetails?.ownerId === "GETMYDRIVE" ? "GETMYDRIVE" : <a href={`/associate/${carDetails?.ownerId}`} target="_blank" rel="noreferrer" className="d-inline-block text-primary text-underline">{carDetails?.ownerId}</a>}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex flex-wrap gap-2 mt-3">
                                                            <Badge
                                                                text={carDetails?.status ? "Active" : "Inactive"}
                                                                icon={
                                                                    carDetails?.status
                                                                        ? <FaCircleCheck />
                                                                        : <MdCancel />
                                                                }
                                                                className={
                                                                    carDetails?.status
                                                                        ? "badge-active"
                                                                        : "badge-inactive"
                                                                }
                                                            />

                                                            <Badge
                                                                text={
                                                                    carDetails?.verified
                                                                        ? "Verified"
                                                                        : "Pending"
                                                                }
                                                                icon={
                                                                    carDetails?.verified
                                                                        ? <BsFillPatchCheckFill />
                                                                        : <BsFillPatchExclamationFill />
                                                                }
                                                                className={
                                                                    carDetails?.verified
                                                                        ? "badge-verified"
                                                                        : "badge-warning"
                                                                }
                                                            />
                                                        </div>

                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="row g-3">
                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Variant
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {carDetails?.variant?.variantName}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Brand
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {carDetails?.brand?.brand}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Segment
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {carDetails?.model?.segment}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Fuel Type
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {Array.isArray(carDetails?.fuelType) ? carDetails?.fuelType.join(", ") : carDetails?.fuelType}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Transmission
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {carDetails?.transmissionType}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Registration No
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {carDetails?.registrationNo}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Year
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {carDetails?.year}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="bg-light rounded-3 p-3">
                                                                    <small className="text-muted d-block">
                                                                        Color
                                                                    </small>
                                                                    <span className="fw-semibold text-capitalize">
                                                                        {carDetails?.color}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {carDetails?.errorMsg ? <label className="text-primary my-2 small">Reason: {carDetails?.errorMsg || ""}</label> : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-5 mt-4 mt-xl-0">
                                        <div className="stats-wrapper p-4 rounded-4">
                                            <div className="row text-center">
                                                <Stat label="Booked" value={carDetails?.Booked} />
                                                <Stat label="Completed" value={carDetails?.Completed} />
                                                <Stat label="Pending" value={carDetails?.Pending} />
                                                <Stat label="Cancelled" value={carDetails?.Cancelled} />
                                            </div>
                                            <hr />
                                            <div>
                                                {
                                                    carDetails?.verificationStage !== 100 &&
                                                    <>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="small text-muted"> Verification Progress </span>
                                                            <span>{verificationStage}%</span>
                                                        </div>
                                                        <div className="progress rounded-pill mt-2">
                                                            <div className="progress-bar bg-success" style={{ width: `${verificationStage}%` }} />
                                                        </div>
                                                    </>
                                                }
                                                <div className="mt-4 text-center" >
                                                    {
                                                        carDetails?.verificationStage !== 100 ?
                                                            canAdvanceStage ? <button className="btn btn-primary btn-sm cursor-pointer" onClick={() => { verificationStage === 50 ? navigate(`/car/device/${id}`) : setStage(true) }} >  <FaExclamation /> Verify</button> : ""
                                                            :
                                                            carDetails?.verificationStatus === "verified" ? <p className="m-0 text-success fs-6 align-center"> <GiCheckMark className="me-2 fs-5" /> Verification Completed </p> : ""
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="stats-wrapper p-3 mt-3 rounded-4">
                                            <div className="row">
                                                {
                                                    carDetails?.features?.map((value, i) => { return (<div key={i} className='my-1 col-md-6 col-xxl-4 col-sm-6 small d-flex align-items-center gap-1' > <span className="d-flex"> {featureIcons?.find((items) => items?.value === value)?.icon}</span> <span> {value}</span></div>) })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>













                    <div className="col-12 col-xl-8">
                        {/* {
                            carDetails?.carImages?.length ?
                                <div className="card border-0 shadow-sm rounded-4 mb-3">
                                    <div className="card-body">
                                        <div className="pb-3">
                                            <div className="d-sm-flex justify-content-between mb-2">
                                                <h5 className="fw-semibold d-flex align-items-center justify-content-sm-start justify-content-center mb-sm-0 mb-2 gap-2"> <FaImage /> Image Details</h5>
                                            </div>
                                            <hr className="m-0" />
                                        </div>
                                        {
                                            carDetails?.carImages?.length
                                                ?
                                                <div className="row align-items-center">
                                                    <div className="col-md-9">
                                                        <div className='position-relative car-view-main'>
                                                            <img src={carDetails?.carImages?.[currentImg]} alt='Main Car' className='img-fluid rounded-5 shadow-sm w-100 object-fit-cover' style={{ height: '400px' }} />
                                                            <div className="car-view-update">
                                                                <button className="btn btn-success" onClick={() => { setUpdateImage({ url: carDetails?.carImages?.[currentImg], file: '', src: carDetails?.carImages?.[currentImg] }); setImageModal(true) }}>View</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 mt-md-0 mt-3">
                                                        <div className='car-slider-wrapper px-3'>
                                                            <Slider {...settings}>
                                                                {carDetails?.carImages?.map((img, index) => (
                                                                    <div key={index} className="px-1 thumbnail-box" onClick={() => setCurrentImg(index)}>
                                                                        <img src={img} alt="thumbnail" className={`img-thumbnail thumb-img p-0 ${currentImg === index ? 'border-primary border-2' : ''}`} />
                                                                    </div>
                                                                ))}
                                                            </Slider>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                ""
                                        }
                                    </div>
                                </div>
                                : ""
                        } */}

                        {rc?.validity && (
                            <DetailCard title="RC Details" icon={<FaCarSide />}>
                                <div className="rc-hero-card position-relative overflow-hidden p-4 p-lg-5 mb-4">
                                    <div className="rc-blur-circle rc-blur-1"></div>
                                    <div className="rc-blur-circle rc-blur-2"></div>

                                    <div className="row align-items-center position-relative z-1">
                                        <div className="col-lg-12">
                                            <div className="d-flex justify-content-between align-items-start" >
                                                <div>
                                                    <h1 className="rc-number">
                                                        {rc?.details?.registrationNumber}
                                                    </h1>

                                                    <h5 className="text-light opacity-75 fw-semibold mb-4">
                                                        {rc?.details?.ownerName}
                                                    </h5>
                                                </div>
                                                <div className="d-flex align-items-center gap-2 mb-3">
                                                    <span className="rc-status-badge active">
                                                        <span className="dot"></span>
                                                        <span className="" >ACTIVE</span>
                                                    </span>
                                                </div>
                                            </div>



                                            <div className="row g-4">
                                                <div className="col-md-4">
                                                    <div className="rc-info-box">
                                                        <p>Registration Date</p>
                                                        <h6>{rc?.details?.registrationDate}</h6>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="rc-info-box">
                                                        <p>Vehicle Class</p>
                                                        <h6>{rc?.details?.class}</h6>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="rc-info-box">
                                                        <p>Vehicle Maker</p>
                                                        <h6>{rc?.details?.maker}</h6>
                                                    </div>
                                                </div>


                                                {/* <div className="col-md-6">
                                                    <div className="rc-info-box">
                                                        <p>Fuel Type</p>
                                                        <h6>{rc?.details?.fuelType}</h6>
                                                    </div>
                                                </div> */}


                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* STATUS PILLS */}
                                <div className="d-flex flex-wrap gap-3 mb-4">
                                    <div className="rc-pill">
                                        🚗 {rc?.details?.class}
                                    </div>

                                    <div className="rc-pill">
                                        ⛽ {rc?.details?.fuelType}
                                    </div>

                                    <div className="rc-pill">
                                        📍 {rc?.details?.placeOfRegistration}
                                    </div>


                                </div>

                                {/* INFO GRID */}
                                <div className="row g-4 mb-5">
                                    <div className="col-md-6 col-xl-4">
                                        <div className="rc-glass-card h-100">
                                            <p className="rc-label">Chassis Number</p>
                                            <h6>{rc?.details?.chassisNumber}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-xl-4">
                                        <div className="rc-glass-card h-100">
                                            <p className="rc-label">Engine Number</p>
                                            <h6>{rc?.details?.engineNumber}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-xl-4">
                                        <div className="rc-glass-card h-100">
                                            <p className="rc-label">Financier</p>
                                            <h6>{rc?.details?.financier}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-xl-4">
                                        <div className="rc-glass-card h-100">
                                            <p className="rc-label">Insurance Provider</p>
                                            <h6>{rc?.details?.insuranceDetails}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-xl-4">
                                        <div className="rc-glass-card h-100">
                                            <p className="rc-label">Insurance Validity</p>
                                            <h6>{rc?.details?.insuranceUpto}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-xl-4">
                                        <div className="rc-glass-card h-100">
                                            <p className="rc-label">Tax Validity</p>
                                            <h6>{rc?.details?.taxUpto}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-xl-4">
                                        <div className="rc-glass-card h-100">
                                            <p className="rc-label">Fitness Valid Till</p>
                                            <h6>{rc?.details?.fitUpto}</h6>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="rc-glass-card">
                                            <p className="rc-label">Registration Address</p>

                                            <h6 className="lh-lg">
                                                {rc?.details?.registrationLocation}
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                            </DetailCard>
                        )}

                        {
                            carDetails?.deviceId ?
                                <div className="card border-0 shadow-sm rounded-4">
                                    <div className="card-body">
                                        <div className="" >
                                            <div className="d-sm-flex justify-content-between mb-2">
                                                <h5 className="fw-semibold d-flex align-items-center justify-content-sm-start justify-content-center mb-sm-0 mb-2 gap-2"> <MdGpsFixed /> Device Details</h5>
                                                <div className="d-flex align-items-center gap-2">
                                                    {canDeviceStep ? <button className="btn p-0 fs-5" onClick={() => navigate(`/car/device/${id}`)}><FiEdit /></button> : ""}
                                                </div>
                                            </div>
                                            <hr className="m-0" />
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Device ID</label><label className="col-sm-8 mb-0">{carDetails?.deviceId || ""}</label> </div>
                                            {/* <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Insurance End</label><label className="col-sm-8 mb-0">{carDetails?.documents?.length ? moment(new Date(carDetails?.documents?.filter((element, i) => element?.documentName === "INSURANCE")[0]?.validity)).format("DD/MM/YYYY") : ""}</label> </div> */}
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Start KM</label><label className="col-sm-8 mb-0">{carDetails?.odometer?.initial || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Fuel Percentage</label><label className="col-sm-8 mb-0">{carDetails?.fuel?.length ? carDetails?.fuel?.map((element, key) => { return element?.type + " - " + element?.percentage + "% " }) : ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Building No</label><label className="col-sm-8 mb-0">{carDetails?.hubDetail?.buildingNo || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Building Name</label><label className="col-sm-8 mb-0">{carDetails?.hubDetail?.buildingName || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Street</label><label className="col-sm-8 mb-0">{carDetails?.hubDetail?.street || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Locality</label><label className="col-sm-8 mb-0">{carDetails?.hubDetail?.area || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">City</label><label className="col-sm-8 mb-0">{carDetails?.hubDetail?.city || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Country</label><label className="col-sm-8 mb-0">{carDetails?.hubDetail?.country || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Pincode</label><label className="col-sm-8 mb-0">{carDetails?.hubDetail?.pincode || ""}</label> </div>
                                            <div className="row align-items-center my-3"><label className="fw-medium col-sm-4 mb-0">Action</label><label className="col-sm-8 mb-0">{canTracking ? <button className="btn btn-success btn-sm" onClick={() => navigate(`/car/tracking/${id}`)}>Track</button> : ""}</label> </div>
                                        </div>
                                    </div>
                                </div>
                                : ""
                        }
                        {
                            carDetails?.priceTypes?.length ?
                                <div className="row" >
                                    <div className="col-7" >
                                        <div className="card border-0 shadow rounded-4 mt-4">
                                            <div className="card-body p-4">
                                                <h5 className="fw-bold mb-0 d-flex align-items-center gap-2">
                                                    <MdOutlineCurrencyRupee size={22} />
                                                    Booking Packages Pricing
                                                </h5>
                                                <hr />
                                                <div className="table-responsive">
                                                    <table className="table table-hover align-middle mb-0 table-borderless" >
                                                        <thead>
                                                            <tr>
                                                                <th>KM Limit</th>
                                                                <th>Price</th>
                                                                <th width="80" className="text-center"> Action </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {carDetails?.priceTypes?.length ? (
                                                                carDetails.priceTypes.map((value, i) => (
                                                                    <tr key={i}>
                                                                        <td><span className="fw-medium"> {value.perHourKm === "1000" ? "Unlimited KM" : `${value.perHourKm} KM`} </span></td>
                                                                        <td><span className="fw-bold text-success"> ₹ {value.perHourPrice} </span></td>
                                                                        <td className="text-center">
                                                                            {canPrice ? <button
                                                                                className="btn btn-sm btn-outline-primary border-0 p-0"
                                                                                onClick={() => {
                                                                                    setPrice({
                                                                                        perHourKm: value?.perHourKm,
                                                                                        perHourPrice: value?.perHourPrice,
                                                                                        package: value?.package
                                                                                    });
                                                                                    setpriceUpdate(true);
                                                                                }} >
                                                                                <FiEdit />
                                                                            </button> : ""}
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={4} className="text-center py-4 text-muted" >
                                                                        No Packages Available
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-5" >
                                        <div className="card border-0 shadow rounded-4 mt-4">
                                            <div className="card-body p-4">
                                                <h5 className="fw-bold mb-0 d-flex align-items-center gap-2">
                                                    <IoShieldCheckmark size={22} />
                                                    Insurance Information
                                                </h5>
                                                <hr className="my-2" />
                                                <div className="d-flex justify-content-between" >
                                                    <div className="text-start">
                                                        <small className="text-muted d-block">
                                                            Provider Name
                                                        </small>
                                                        <span className="fw-semibold fs-6">
                                                            {carDetails?.insurance?.provider_name || "-"}
                                                        </span>
                                                    </div>

                                                    <div className="text-end" >
                                                        <small className="text-muted d-block">
                                                            Insurance Amount
                                                        </small>
                                                        <span className="fw-semibold fs-6">
                                                            ₹ {carDetails?.insurance?.amount || 0}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card border-0 shadow rounded-4 mt-4">
                                            <div className="card-body p-4">
                                                <h5 className="fw-bold mb-0 d-flex align-items-center gap-2">
                                                    <CiCreditCard2 size={22} />
                                                    FasTag Information
                                                </h5>
                                                <hr className="my-2" />
                                                <div className="d-flex justify-content-between" >
                                                    <div className="text-start">
                                                        <small className="text-muted d-block">
                                                            Provider Name
                                                        </small>
                                                        <span className="fw-semibold fs-6">
                                                            {carDetails?.fasTag?.provider_name || "-"}
                                                        </span>
                                                    </div>

                                                    <div className="text-end" >
                                                        <small className="text-muted d-block">
                                                            Balance
                                                        </small>
                                                        <span className="fw-semibold fs-6">
                                                            ₹ {carDetails?.fasTag?.balance || 0}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ""
                        }

                        {/* Each tile opens the replace-document modal, so the whole
                            card is an action surface - hidden without the capability. */}
                        {canDocuments ? (
                            <div className="card border-0 shadow-sm rounded-4 my-4">
                                <div className="p-3">
                                    <div className="d-flex justify-content-between align-items-center mb-1" >
                                        <h5 className="fw-semibold d-flex align-items-center gap-2 mb-0">
                                            <IoDocumentTextSharp /> Documents
                                        </h5>
                                    </div>
                                    <hr className="m-0" />
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        <KycCard
                                            title="RC"
                                            verified={!!rc?.documentUrl}
                                            icon={<FaBook />}
                                            onClick={() => {
                                                setDocDetail({ url: "", validity: "" });
                                                setDocDetail(rc);
                                                setDocEditModal(true);
                                            }}
                                        />

                                        <KycCard
                                            title="PUC"
                                            verified={!!carDetails?.documents?.find(element => element.documentName === "PUC")?.documentUrl}
                                            icon={<PiCertificateFill />}
                                            onClick={() => {
                                                setDocDetail({ url: "", validity: "" });
                                                setDocDetail(carDetails?.documents?.find(element => element.documentName === "PUC") || { documentName: "PUC" });
                                                setDocEditModal(true);
                                            }}
                                        />

                                        <KycCard
                                            title="Insurance"
                                            verified={!!carDetails?.documents?.find(element => element.documentName === "INSURANCE")?.documentUrl}
                                            icon={<SiAdguard />}
                                            onClick={() => {
                                                setDocDetail({ url: "", validity: "" });
                                                setDocDetail(carDetails?.documents?.find(element => element.documentName === "INSURANCE") || { documentName: "INSURANCE" });
                                                setDocEditModal(true);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : ""}
                        <div className="card border-0 shadow-sm rounded-4 my-4">
                            <div className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-1" >
                                    <h5 className="fw-semibold d-flex align-items-center gap-2 mb-0">
                                        <IoDocumentTextSharp /> Documents & Warranty
                                    </h5>
                                    {canDocuments ? <button className="btn btn-primary me-2" onClick={() => setDocumentUpload(true)}  > <IoCloudUploadOutline /> Upload</button> : ""}
                                </div>
                                <hr className="m-0" />
                            </div>
                            <div className="card-body">
                                <table className="table" >
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Validity</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {carDetails?.documents?.length ? carDetails?.documents?.map((doc, i) => { return <tr key={i} ><td className="text-capitalize" >{doc?.documentName}</td><td>{doc?.validity ? showZoneDate(doc?.validity) : "-"}</td><td> {doc?.documentUrl ? <a href={doc?.documentUrl} target="_blank" rel="noreferrer" className="btn btn-primary" >View</a> : ""}</td></tr> }) : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            carDetails?.hub && carDetails?.priceTypes?.length
                                ?
                                <>
                                    {canService ? <Service /> : ""}
                                    {canBookings ? <BookingDetails /> : ""}
                                </>
                                : ""
                        }
                    </div>
                    {canTimeline ? <div className="col-12 col-xl-4 mt-xl-0 mt-3"> <Timeline userLog={userLog} /></div> : ""}
                </div>
            </div>






            {status && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation</h5>
                                <button className="btn-close" onClick={() => setStatus(false)}></button>
                            </div>
                            <div className="modal-body">
                                <label htmlFor="departmentName" className="form-label mb-3"> Do you really wanna {carDetails?.status ? "Deactivate" : "Activate"} this customer ? </label>
                                {carDetails?.status ? <input autoComplete="off" value={carDetails.reason || ""} name="reason" onChange={(e) => setCarDetails((prev) => ({ ...prev, reason: e.target.value }))} type="text" className="form-control" placeholder="Reason" /> : ""}
                            </div>
                            <div className="modal-footer align-items-center justify-content-center">
                                <button disabled={loading} className="btn btn-success" onClick={statusUpdate}>Yes</button>
                                <button disabled={loading} className="btn btn-danger" onClick={() => setStatus(false)}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {stage && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{verificationStage === 20 ? "Car " : verificationStage === 50 ? "Device " : verificationStage === 70 ? "Price " : ""} Details</h5>
                                <button className="btn-close" onClick={() => setStage(false)}></button>
                            </div>
                            <div className="modal-body">
                                {!canAdvanceStage ? "" : verificationStage === 20 ? <CarImages /> : verificationStage === 50 ? <DeviceRegister /> : verificationStage === 70 ? <CarVerification modelClose={setStage} /> : ""}
                            </div>
                            {/* <div className="modal-footer align-items-center justify-content-center">
                                <button disabled={loading} className="btn btn-success" onClick={statusUpdate}>Yes</button>
                                <button disabled={loading} className="btn btn-danger" onClick={() => setStatus(false)}>No</button>
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
            {imageModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title"> Image View </h5>
                                <button className="btn-close" onClick={() => setImageModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="car-view-main">
                                    <img src={updateImage?.url} alt='Main Car' className='img-fluid rounded-5 shadow-sm w-100 object-fit-cover' style={{ height: '400px' }} />
                                    {canImages ? <div className="text-center mt-3"> <label htmlFor="image" className="cursor-pointer"><FaCloudUploadAlt /> Upload</label></div> : ""}
                                    <input autoComplete='off' disabled={loading} id="image" onChange={(e) => setUpdateImage((prev) => ({ ...prev, url: URL.createObjectURL(e.target.files[0]), file: e.target.files[0] }))} type='file' multiple="multiple" accept="image/png,image/jpeg" className="d-none" />
                                </div>
                            </div>
                            {updateImage?.file ?
                                <div className="modal-footer align-items-center justify-content-center">
                                    <button disabled={loading} className="btn btn-success" onClick={imageChange}>Update</button>
                                </div>
                                : ""}
                        </div>
                    </div>
                </div>
            )}
            {document?.modal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title"> Document View </h5>
                                <button className="btn-close" onClick={() => setDocument({ modal: false })}></button>
                            </div>
                            <div className="modal-body">
                                <div className='d-flex document-image'>
                                    {
                                        document?.value?.documentUrl?.slice(-3) === "pdf" ?
                                            <iframe src={document?.value?.documentUrl} title='Documents' width="100%" height="600px" />
                                            : <img src={document?.value?.documentUrl} alt='Documents' />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {documentUpload && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title"> Document Upload </h5>
                                <button className="btn-close" onClick={() => setDocumentUpload(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <label htmlFor="documentName" className="col-md-3 col-form-label"> Name</label>
                                    <div className="col-md-9">
                                        <input autoComplete="off" type="text" className="form-control" id="documentName" value={documentUploadDetails?.documentName} disabled={loading} onChange={(e) => setDocumentUploadDetails((prev) => ({ ...prev, documentName: e?.target?.value }))} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="price" className="form-label col-md-3"> Validity </label>
                                    <div className="col-md-9">
                                        <DatePicker value={new Date(documentUploadDetails?.documentValidity)} disabled={loading} inputClass="form-control" onChange={(e) => setDocumentUploadDetails(prev => ({ ...prev, documentValidity: new Date(e) }))} minDate={new Date()} />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <label htmlFor="image" className="form-label col-md-3"> Document</label>
                                    <div className="col-md-9">
                                        <input className='form-control' accept='application/pdf' autoComplete='off' disabled={loading} id="image" name="image" type="file" onChange={(e) => { setDocumentUploadDetails(prev => ({ ...prev, document: e.target.files[0] })) }} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer align-items-center justify-content-center">
                                <button className="btn btn-success" disabled={loading} onClick={uploadDocument}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {docEditModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title"> Document Edit </h5>
                                <button className="btn-close" onClick={() => setDocEditModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3 align-items-center">
                                    <label htmlFor="image" className="form-label col-md-3"> {docDetail?.documentName}</label>
                                    <div className="col-md-9">
                                        <input className='form-control' accept='application/pdf' autoComplete='off' disabled={loading} id="image" name="image" type="file" onChange={(e) => { setDocDetail(prev => ({ ...prev, url: e.target.files[0] })) }} />
                                    </div>
                                </div>
                                {docDetail?.documentName === "RC" ? "" :
                                    <div className="row">
                                        <label htmlFor="price" className="form-label col-md-3"> Validity </label>
                                        <div className="col-md-9">
                                            <DatePicker value={new Date(docDetail?.validity)} disabled={loading} inputClass="form-control w-100" onChange={(e) => setDocDetail(prev => ({ ...prev, validity: new Date(e) }))} minDate={new Date()} />
                                        </div>
                                    </div>}
                            </div>
                            <div className="modal-footer align-items-center justify-content-center">
                                <button className="btn btn-success" disabled={loading} onClick={updateDocument}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {priceUpdate && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title"> Price Edit </h5>
                                <button className="btn-close" onClick={() => setpriceUpdate(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3 align-items-center">
                                    <label htmlFor="perHourKm" className="col-md-3 form-label"> KM Per Hour </label>
                                    <div className="col-md-9" md={0}>
                                        <input autoComplete='off' id="perHourKm" name="perHourKm" className="form-control" placeholder="KM Per Hour" type="text" value={price?.perHourKm} disabled onChange={(e) => { if (e.target.value === Number(e.target.value)) { setPrice((prev) => ({ ...prev, perHourKm: e.target.value })) } }} />
                                    </div>
                                </div>
                                <div className="row align-items-center">
                                    <label htmlFor="price" md={3} className="col-md-3 form-label"> Price </label>
                                    <div className="col-md-9" md={0}>
                                        <input placeholder="Price" className="form-control" autoComplete='off' value={price?.perHourPrice} id='price' name='price' onChange={(e) => {
                                            if (/^\d{0,}$/.test(e.target.value) || e.target.value === "") {
                                                setPrice((prev) => ({ ...prev, perHourPrice: e.target.value }))
                                            }
                                        }} disabled={loading} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer align-items-center justify-content-center">
                                <button className="btn btn-success" disabled={loading} onClick={handlePriceUpdate}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {status || stage || imageModal || document?.modal || docEditModal || priceUpdate || documentUpload ? <div className="modal-backdrop fade show"></div> : ""}
        </React.Fragment>
    )
}

export default View;